import { useImportContext } from '../../../../../components/csv-import/ui/components/import-context';
import { ConfigStepFooter } from '../../../../../components/csv-import/ui/components/steps/create-config-step/create-config-step';

/**
 * @returns {React.JSX.Element}
 */
export const TotesConfigStepFooter = () => {
  const { form } = useImportContext();
  return <ConfigStepFooter isInitImportBtnDisabled={!form.inventoryWarehouse} />;
};
